// import React, { memo, useEffect, useState , useRef } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import { closeCheckIn, closeCheckOut } from './../../../../Redux/action/interactions';
// import toast from 'react-hot-toast';

// import CheckIn from './../CheckIn/CheckIn';
// import classes from './CheckInOutButtonDiv.module.scss';
// import CheckInImg from './../../../../assets/icons/Enter_House.svg'
// import CheckOutImg from './../../../../assets/icons/Leave_House.svg'
// import locationImg from './../../../../assets/icons/Location_on_orange.svg'
// import { fetchLocation } from '../../../../API/API';

// const CheckInOutButtonDiv = () => {
//     const dispatch = useDispatch();
//     const closeCheckInBox = useSelector((state) => state.login.closeCheckIn);
//     const closeCheckOutBox = useSelector((state) => state.login.closeCheckOut);
//     const [locationFetched, setLocationFetched] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [cmd, setCmd] = useState("");

//     const GPS_DISABLED = useRef(null)

//     const openCheckIn = (clickCMD) => {
//         setCmd(clickCMD.toString());
//         fetchLocation()
//             .then((response) => {
//                 if (response) {
//                     dispatch(closeCheckIn(true));
//                     setLocationFetched(response);
//                 }
//             })
//             .catch((error) => {
//                 toast(error.message, {
//                     icon: '❗',
//                     duration: 4500
//                 });
//             });
//     }

//     const openCheckOut = (clickCMD) => {
//         setCmd(clickCMD.toString());
//         fetchLocation()
//             .then((response) => {
//                 if (response) {
//                     dispatch(closeCheckOut(true));
//                     setLocationFetched(response);
//                 }
//             })
//             .catch((error) => {
//                 toast(error.message, {
//                     icon: '❗',
//                     duration: 4500
//                 });
//             });

//     }

//     useEffect(() => {

//         if (window.env) {
//             GPS_DISABLED.current = window.env.ERROR.GPS_DISABLED
//         } else {
//             toast.error("Problem in getting ENV File");
//         }

//         const fetcher = setTimeout(() => {
//             const parsedLocation = JSON.parse(localStorage.getItem('fetchedLoc'));
//             if (parsedLocation !== null) {
//                 setLocationFetched(parsedLocation);
//                 setLoading(false);
//             } else {
//                 setLoading(false)
//                 setLocationFetched({ location: "Not Able to Fetch Location" });
//                 toast(GPS_DISABLED.current,{
//                     icon:"❗",
//                     duration:4500
//                 })
//             }
//         }, 4000);

//         return () => {
//             clearTimeout(fetcher);
//         };
//     }, []);

//     const refreshLocation = () => {
//         setLoading(true)
//         fetchLocation()
//             .then((response) => {

//                 localStorage.setItem('fetchedLoc', JSON.stringify(response));

//                 setTimeout(() => {
//                     setLoading(false)
//                     setLocationFetched(response);
//                 }, 3000);

//             })
//             .catch((error) => {
//                 setLoading(false)
//                 setLocationFetched({ location: "SITE" });
//                 toast.error(error.message);
//             });
//     };


//     return (
//         <>

//             <div className={classes.CheckInButtonDiv}>
//                 {closeCheckInBox ? <CheckIn loading={loading} location={locationFetched} cmd="CheckIn" /> : " "}
//                 {closeCheckOutBox ? <CheckIn loading={loading} location={locationFetched} cmd="CheckOut" /> : " "}
//                 <h2>Current Location</h2>
//                 <p onLoad={refreshLocation}>
//                     <img src={locationImg} alt="" width={14} />
//                     {loading ? "...Loading Your Location" : locationFetched.location.replace(/_/g, " ")}
//                 </p>


//                 {loading ?
//                     " "
//                     : (<>
//                         <span onClick={refreshLocation} className={classes.RefreshButton}>
//                             Refresh Location
//                             <span className="material-icons">
//                                 autorenew
//                             </span>
//                         </span>
//                         <div className={classes.ButtonsDiv}>
//                             <button onClick={() => { openCheckIn('CheckIn') }}>
//                                 <img src={CheckInImg} alt="EnterHouse" width={20} />
//                                 Check In
//                             </button>
//                             <button style={{ backgroundColor: '#0091D5' }} onClick={() => { openCheckOut('CheckOut') }} >
//                                 <img src={CheckOutImg} alt="EnterHouse" width={20} />
//                                 Check Out
//                             </button>
//                             </div>
//                     </>)
//                 }


//             </div>
//         </>
//     )
// }

// export default CheckInOutButtonDiv











// import React, { memo, useEffect, useState , useRef } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import { closeCheckIn, closeCheckOut } from './../../../../Redux/action/interactions';
// import toast from 'react-hot-toast';

// import CheckIn from './../CheckIn/CheckIn';
// import classes from './CheckInOutButtonDiv.module.scss';
// import CheckInImg from './../../../../assets/icons/Enter_House.svg'
// import CheckOutImg from './../../../../assets/icons/Leave_House.svg'
// import locationImg from './../../../../assets/icons/Location_on_orange.svg'
// import { fetchLocation } from '../../../../API/API';

// const CheckInOutButtonDiv = () => {
//     const dispatch = useDispatch();
//     const closeCheckInBox = useSelector((state) => state.login.closeCheckIn);
//     const closeCheckOutBox = useSelector((state) => state.login.closeCheckOut);
//     const [locationFetched, setLocationFetched] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [cmd, setCmd] = useState("");
//     const [buttonVis, setButtonVis] = useState("");
//     const [notPermSiteMsg, setNotPermSiteMsg] = useState("");
//     const [locName, setLocName] = useState("");
//     const [prevLocCoords, setPrevLocCoords] = useState("");

//     const GPS_DISABLED = useRef(null)

//     const openCheckIn = (clickCMD) => {
//         setCmd(clickCMD.toString());
//         fetchLocation()
//             .then((response) => {
//                 if (response) {
//                     dispatch(closeCheckIn(true));
//                     setLocationFetched(response);
//                 }
//             })
//             .catch((error) => {
//                 toast(error.message, {
//                     icon: '❗',
//                     duration: 4500
//                 });
//             });
//     }

//     const openCheckOut = (clickCMD) => {
//         setCmd(clickCMD.toString());
//         fetchLocation()
//             .then((response) => {
//                 if (response) {
//                     dispatch(closeCheckOut(true));
//                     setLocationFetched(response);
//                 }
//             })
//             .catch((error) => {
//                 toast(error.message, {
//                     icon: '❗',
//                     duration: 4500
//                 });
//             });

//     }

//     useEffect(() => {

//         if (window.env) {
//             GPS_DISABLED.current = window.env.ERROR.GPS_DISABLED
//         } else {
//             toast.error("Problem in getting ENV File");
//         }

//         const fetcher = setTimeout(() => {
//             const parsedLocation = JSON.parse(localStorage.getItem('fetchedLoc'));
//             if (parsedLocation !== null) {
//                 setLocationFetched(parsedLocation);
//                 setLoading(false);
//             } else {
//                 setLoading(false)
//                 setLocationFetched({ location: "Not Able to Fetch Location" });
//                 toast(GPS_DISABLED.current,{
//                     icon:"❗",
//                     duration:4500
//                 })
//             }
//         }, 4000);

//         return () => {
//             clearTimeout(fetcher);
//         };
//     }, []);

//     const refreshLocation = () => {
//         setLoading(true)
//         fetchLocation()
//             .then((response) => {

//                 localStorage.setItem('fetchedLoc', JSON.stringify(response));

//                 setTimeout(() => {
//                     setLoading(false)
//                     setLocationFetched(response);
//                 }, 3000);

//             })
//             .catch((error) => {
//                 setLoading(false)
//                 setLocationFetched({ location: "SITE" });
//                 toast.error(error.message);
//             });
//     };
// // Added for Hiding CheckIn Check Out in case of Non-permitted Site
//     useEffect(() => {
//         if(!locationFetched) return;
//         if(locationFetched.latlong) {

//             if (prevLocCoords != locationFetched.latlong) {
//                 fetch("https://nominatim.openstreetmap.org/search.php?q="+locationFetched.latlong+"&polygon_geojson=1&format=json",
//                 {
//                     headers: {
//                         'User-Agent': 'AttendanceAppv0.1'
//                     }
//                 })
//                 .then(response => response.json())
//                 .then(j => {
//                     console.log(j)
//                     setLocName(j[0].display_name)
//                 })
//             }
//             setPrevLocCoords(locationFetched.latlong)
//         }
//         // let permittedSites = JSON.parse(localStorage.getItem('data')).sites.toUpperCase();
//         let permittedSites = JSON.parse(localStorage.getItem('data')).sites;
//         if(!permittedSites) permittedSites="NONE";
//         // if (permittedSites.indexOf(locationFetched.location.toUpperCase()) >= 0) {
//             if (permittedSites.indexOf(locationFetched.location) >= 0) {
//             setButtonVis("");
//             setNotPermSiteMsg("");
//         }
//         else {
//             setButtonVis("none");
//             setNotPermSiteMsg("You are on Non permitted Site, please mark manual attendance. \n\nSite(s) Permitted for marking Attendance: "+permittedSites+"\n\nYour Site: ");
//         }
//         console.log(permittedSites, locationFetched.location, buttonVis, notPermSiteMsg, locName);
//     }, [locationFetched]);

//     return (
//         <>

//             <div className={classes.CheckInButtonDiv}>
//                 {closeCheckInBox ? <CheckIn loading={loading} location={locationFetched} cmd="CheckIn" /> : " "}
//                 {closeCheckOutBox ? <CheckIn loading={loading} location={locationFetched} cmd="CheckOut" /> : " "}
//                 <h2>Current Location</h2>
//                 <p onLoad={refreshLocation}>
//                     <img src={locationImg} alt="" width={14} />
//                     {loading ? "...Loading Your Location" : locationFetched.location.replace(/_/g, " ")}
//                 </p>


//                 {loading ?
//                     " "
//                     : (<>
//                         <span onClick={refreshLocation} className={classes.RefreshButton}>
//                             Refresh Location
//                             <span className="material-icons">
//                                 autorenew
//                             </span>
//                         </span>
//                         <div className={classes.ButtonsDiv}>
//                             <center><h3 style={{whiteSpace:"pre-wrap"}}>{notPermSiteMsg} {notPermSiteMsg && locName}</h3></center>
//                             <button style={{"display":buttonVis }} onClick={() => { openCheckIn('CheckIn') }}>
//                                 <img src={CheckInImg} alt="EnterHouse" width={20} />
//                                 Check In
//                             </button>
//                             <button style={{ backgroundColor: '#0091D5', "display":buttonVis }} onClick={() => { openCheckOut('CheckOut') }} >
//                                 <img src={CheckOutImg} alt="EnterHouse" width={20} />
//                                 Check Out
//                             </button>
//                             </div>
//                     </>)
//                 }


//             </div>
//         </>
//     )
// }

// export default CheckInOutButtonDiv


/////////////////////////////////////////////////////////////////
/////////  Running Code::::
/////////////////////////////////////////////////////////////////


// import React, { memo, useEffect, useState, useRef } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import { closeCheckIn, closeCheckOut } from './../../../../Redux/action/interactions';
// import toast from 'react-hot-toast';

// import CheckIn from './../CheckIn/CheckIn';
// import classes from './CheckInOutButtonDiv.module.scss';
// import CheckInImg from './../../../../assets/icons/Enter_House.svg'
// import CheckOutImg from './../../../../assets/icons/Leave_House.svg'
// import locationImg from './../../../../assets/icons/Location_on_orange.svg'
// import { fetchLocation } from '../../../../API/API';

// const CheckInOutButtonDiv = () => {
//     const dispatch = useDispatch();
//     const closeCheckInBox = useSelector((state) => state.login.closeCheckIn);
//     const closeCheckOutBox = useSelector((state) => state.login.closeCheckOut);
//     const [locationFetched, setLocationFetched] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [cmd, setCmd] = useState("");

//     const GPS_DISABLED = useRef(null);

//     const openCheckIn = (clickCMD) => {
//         setCmd(clickCMD.toString());
//         fetchLocation()
//             .then((response) => {
//                 if (response) {
//                     dispatch(closeCheckIn(true));
//                     setLocationFetched(response);
//                 }
//             })
//             .catch((error) => {
//                 toast(error.message, {
//                     icon: '❗',
//                     duration: 4500
//                 });
//             });
//     }

//     const openCheckOut = (clickCMD) => {
//         setCmd(clickCMD.toString());
//         fetchLocation()
//             .then((response) => {
//                 if (response) {
//                     dispatch(closeCheckOut(true));
//                     setLocationFetched(response);
//                 }
//             })
//             .catch((error) => {
//                 toast(error.message, {
//                     icon: '❗',
//                     duration: 4500
//                 });
//             });
//     }

//     useEffect(() => {
//         if (window.env) {
//             GPS_DISABLED.current = window.env.ERROR.GPS_DISABLED;
//         } else {
//             toast.error("Problem in getting ENV File");
//         }

//         const fetcher = setTimeout(() => {
//             const parsedLocation = JSON.parse(localStorage.getItem('fetchedLoc'));
//             if (parsedLocation !== null) {
//                 setLocationFetched(parsedLocation);
//                 setLoading(false);
//             } else {
//                 setLoading(false);
//                 setLocationFetched({ location: "Not Able to Fetch Location" });
//                 toast(GPS_DISABLED.current, {
//                     icon: "❗",
//                     duration: 4500
//                 });
//             }
//         }, 4000);

//         return () => {
//             clearTimeout(fetcher);
//         };
//     }, []);

//     const refreshLocation = () => {
//         setLoading(true);
//         fetchLocation()
//             .then((response) => {
//                 localStorage.setItem('fetchedLoc', JSON.stringify(response));

//                 setTimeout(() => {
//                     setLoading(false);
//                     setLocationFetched(response);
//                 }, 3000);

//             })
//             .catch((error) => {
//                 setLoading(false);
//                 setLocationFetched({ location: "SITE" });
//                 toast.error(error.message);
//             });
//     };

//     return (
//         <>
//             <div className={classes.CheckInButtonDiv}>
//                 {closeCheckInBox ? <CheckIn loading={loading} location={locationFetched} cmd="CheckIn" /> : " "}
//                 {closeCheckOutBox ? <CheckIn loading={loading} location={locationFetched} cmd="CheckOut" /> : " "}
//                 <h2>Current Location</h2>
//                 <p onLoad={refreshLocation}>
//                     <img src={locationImg} alt="" width={14} />
//                     {loading ? "...Loading Your Location" : locationFetched.location.replace(/_/g, " ")}
//                 </p>

//                 {loading ? " " : (
//                     <>
//                         <span onClick={refreshLocation} className={classes.RefreshButton}>
//                             Refresh Location
//                             <span className="material-icons">
//                                 autorenew
//                             </span>
//                         </span>
//                         {locationFetched.location === "SITE" ? (
//                             <p onLoad={refreshLocation}><b>Marking Attendance at site location is prohibited</b></p>
//                         ) : (
//                             <div className={classes.ButtonsDiv}>
//                                 <button onClick={() => { openCheckIn('CheckIn') }}>
//                                     <img src={CheckInImg} alt="EnterHouse" width={20} />
//                                     Check In
//                                 </button>
//                                 <button style={{ backgroundColor: '#0091D5' }} onClick={() => { openCheckOut('CheckOut') }} >
//                                     <img src={CheckOutImg} alt="EnterHouse" width={20} />
//                                     Check Out
//                                 </button>
//                             </div>
//                         )}
//                     </>
//                 )}
//             </div>
//         </>
//     );
// }

// export default CheckInOutButtonDiv;


////////////////////////////////////////////////////////////
//////////////Testing Code for "Not Able to Fetched Location //Checkin and CheckOut Buttons"::::::
////////////////////////////////////////////////////////////
import React, { memo, useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { closeCheckIn, closeCheckOut } from './../../../../Redux/action/interactions';
import toast from 'react-hot-toast';

import CheckIn from './../CheckIn/CheckIn';
import classes from './CheckInOutButtonDiv.module.scss';
import CheckInImg from './../../../../assets/icons/Enter_House.svg';
import CheckOutImg from './../../../../assets/icons/Leave_House.svg';
import locationImg from './../../../../assets/icons/Location_on_orange.svg';
import { fetchLocation } from '../../../../API/API';

const CheckInOutButtonDiv = () => {
    const dispatch = useDispatch();
    const closeCheckInBox = useSelector((state) => state.login.closeCheckIn);
    const closeCheckOutBox = useSelector((state) => state.login.closeCheckOut);
    const [locationFetched, setLocationFetched] = useState(null);
    const [loading, setLoading] = useState(true);
    const [cmd, setCmd] = useState("");

    const GPS_DISABLED = useRef(null);

    const openCheckIn = (clickCMD) => {
        setCmd(clickCMD.toString());
        fetchLocation()
            .then((response) => {
                if (response) {
                    dispatch(closeCheckIn(true));
                    setLocationFetched(response);
                }
            })
            .catch((error) => {
                toast(error.message, {
                    icon: '❗',
                    duration: 4500
                });
            });
    };

    const openCheckOut = (clickCMD) => {
        setCmd(clickCMD.toString());
        fetchLocation()
            .then((response) => {
                if (response) {
                    dispatch(closeCheckOut(true));
                    setLocationFetched(response);
                }
            })
            .catch((error) => {
                toast(error.message, {
                    icon: '❗',
                    duration: 4500
                });
            });
    };

    useEffect(() => {
        if (window.env) {
            GPS_DISABLED.current = window.env.ERROR.GPS_DISABLED;
        } else {
            toast.error("Problem in getting ENV File");
        }

        const fetcher = setTimeout(() => {
            const parsedLocation = JSON.parse(localStorage.getItem('fetchedLoc'));
            if (parsedLocation !== null) {                          // "==" compare two values on both side::
                setLocationFetched(parsedLocation);
                setLoading(false);
            } else {
                setLoading(false);
                setLocationFetched({ location: "Not Able to Fetch Location" });
                toast(GPS_DISABLED.current, {
                    icon: "❗",
                    duration: 4500
                });
            }
        }, 4000);

        return () => {
            clearTimeout(fetcher);
        };
    }, []);

    const refreshLocation = () => {
        setLoading(true);
        fetchLocation()
            .then((response) => {
                localStorage.setItem('fetchedLoc', JSON.stringify(response));
                setTimeout(() => {
                    setLoading(false);
                    setLocationFetched(response);
                }, 3000);                                //3000
            })
            .catch((error) => {
                setLoading(false);
                setLocationFetched({ location: "SITE" });
                toast.error(error.message);
            });
    };

    return (
        <div className={classes.CheckInButtonDiv}>
            {closeCheckInBox ? <CheckIn loading={loading} location={locationFetched} cmd="CheckIn" /> : " "}
            {closeCheckOutBox ? <CheckIn loading={loading} location={locationFetched} cmd="CheckOut" /> : " "}
            <h2>Current Location</h2>
            <p onLoad={refreshLocation}>
                <img src={locationImg} alt="" width={14} />
                {loading ? "...Loading Your Location" : locationFetched.location.replace(/_/g, " ")}
            </p>

            {loading ? " " : (
                <>
                    <span onClick={refreshLocation} className={classes.RefreshButton}>
                        Refresh Location
                        <span className="material-icons">
                            autorenew
                        </span>
                    </span>
                    {locationFetched.location === "SITE" ? (
                        <p><b>Marking Attendance at site location is prohibited</b></p>    //"===" check the types and values...
                    ) : locationFetched.location === "Not Able to Fetch Location" ? (      // We added the new Conditions for Hiding the buttons when the "Not Able to Fetch Location".
                        <p><b>Unable to fetch location. Please try refreshing.</b></p>     
                    ) : (
                        <div className={classes.ButtonsDiv}>
                            <button onClick={() => { openCheckIn('CheckIn') }}>
                                <img src={CheckInImg} alt="EnterHouse" width={20} />
                                Check In
                            </button>
                            <button style={{ backgroundColor: '#0091D5' }} onClick={() => { openCheckOut('CheckOut') }}>
                                <img src={CheckOutImg} alt="EnterHouse" width={20} />
                                Check Out
                            </button>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default memo(CheckInOutButtonDiv);





///////////////////////////////////////////////////////////////////////////////////////////////////////////////


















